import Vue from 'vue'

// axios
import axios from 'axios'

let site = window.location.origin
if (site === 'http://localhost:8080' && localStorage.getItem('devsite')) {
  site = localStorage.getItem('devsite')
}
const obj = {
  site_admin: site,
  // site_admin: 'https://admin.ufa-bak-7777.com',
}
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // baseURL: endpoint,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})
axiosIns.interceptors.request.use(
  async config => {
    await axios.post('https://api.ufa-bak-7777.com/api/agent/showid', obj)
    // eslint-disable-next-line no-unused-vars
      .then(response => {
        localStorage.setItem('endpoint', response.data.endpoint)
        // eslint-disable-next-line no-param-reassign
        config.baseURL = response.data.endpoint
        // eslint-disable-next-line no-param-reassign
        // config.baseURL = 'http://127.0.0.1:9090/api/'
      })
      .catch(error => console.log(error))
    // console.log(config.headers.Authorization)

    return config
  },
  error => Promise.reject(error),
)
Vue.prototype.$http = axiosIns

export default axiosIns
